import { get, getAll } from "../utilites/querySelector";


export const modalContainer = get( '.site-modal' );

export const closeButton = get( '[data-modal-close]', modalContainer );

export const modalForm = modalContainer.querySelector('.wpcf7');

export const modalMain = modalContainer.querySelector('.site-modal__main')

modalForm.addEventListener( 'wpcf7submit', scrollToBottom);

closeButton.addEventListener( 'click', fadeout );



const openers = getAll( '[data-modal-open]' );
openers.forEach( opener => {
    opener.addEventListener( 'click', () => {
        activate( opener.dataset.modalOpen );
    } );
} );

const strayContactOpeners = getAll( '[href^="#modal-form"]' );
strayContactOpeners.forEach( opener => {
    opener.addEventListener( 'click', ( e ) => {
        e.preventDefault();
        activate( 'contact' );
    } );
} );

/**
 * "Activates" the specified modal, opening the modal in the process
 * @param {string} modalName
 */
export function activate( modalName ) {
    get( `[data-modal=${modalName}]`, modalContainer ).dataset.active = true;
    modalContainer.dataset.active = true;
    fadein();
}

/**
 * Sets the active state of all modals to false
 */
function deactivate() {
    modalContainer.dataset.active = false;
    getAll( `[data-active=true]`, modalContainer ).forEach( activeModal => activeModal.dataset.active = false );

    // Remove status of contact form
    get( '.wpcf7-form', modalContainer )?.reset();
}

/**
 * Opens the main modal up
 */
function fadein() {
    modalContainer.animate( {
        opacity: [0, 1],
        transform: ['translateY(1rem)', 'translateY(0)']
    }, { duration: 350, easing: 'ease' } );
}

function fadeout() {
    const animation = modalContainer.animate( {
        opacity: [1, 0],
        transform: ['translateY(0)', 'translateY(-1rem)']
    }, { duration: 350, easing: 'ease' } );
    animation.addEventListener( 'finish', () => {
        deactivate();
    } );
}

function scrollToBottom() {
    modalMain.scrollTop = modalMain.scrollHeight;
};